import {server} from '../Data/BuildEnvironment'
import {HttpRequest} from '../Data/HttpRequest'
import * as LoginData from '../Entities/LoginData'

export function submit(data: LoginData.M): HttpRequest {
    return {
        verb: 'POST',
        url: `${server}/login`,
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(data),
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Request/LoginResource.ts